var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.19,
    height: 23.87,
    viewBox: "0 0 25.19 23.87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0417 0.986328C15.8776 0.986328 16.5552 1.66395 16.5552 2.49984V7.16651C16.5552 8.0024 15.8776 8.68002 15.0417 8.68002C14.2058 8.68002 13.5282 8.0024 13.5282 7.16651V6.34669H2.20834C1.37245 6.34669 0.694824 5.66907 0.694824 4.83317C0.694824 3.99728 1.37245 3.31966 2.20834 3.31966H13.5282V2.49984C13.5282 1.66395 14.2058 0.986328 15.0417 0.986328ZM18.1948 4.83317C18.1948 3.99728 18.8724 3.31966 19.7083 3.31966H23.2083C24.0442 3.31966 24.7219 3.99728 24.7219 4.83317C24.7219 5.66907 24.0442 6.34669 23.2083 6.34669H19.7083C18.8724 6.34669 18.1948 5.66907 18.1948 4.83317ZM11.5417 9.153C12.3776 9.153 13.0552 9.83062 13.0552 10.6665V11.4863H24.375C25.2109 11.4863 25.8885 12.164 25.8885 12.9998C25.8885 13.8357 25.2109 14.5134 24.375 14.5134H13.0552V15.3332C13.0552 16.1691 12.3776 16.8467 11.5417 16.8467C10.7058 16.8467 10.0282 16.1691 10.0282 15.3332V10.6665C10.0282 9.83062 10.7058 9.153 11.5417 9.153ZM0.694824 12.9998C0.694824 12.164 1.37245 11.4863 2.20834 11.4863H6.875C7.71089 11.4863 8.38852 12.164 8.38852 12.9998C8.38852 13.8357 7.71089 14.5134 6.875 14.5134H2.20834C1.37245 14.5134 0.694824 13.8357 0.694824 12.9998ZM15.0417 17.162C15.8776 17.162 16.5552 17.8396 16.5552 18.6755V23.3422C16.5552 24.1781 15.8776 24.8557 15.0417 24.8557C14.2058 24.8557 13.5282 24.1781 13.5282 23.3422V22.68H2.20834C1.37245 22.68 0.694824 22.0024 0.694824 21.1665C0.694824 20.3306 1.37245 19.653 2.20834 19.653H13.5282V18.6755C13.5282 17.8396 14.2058 17.162 15.0417 17.162ZM18.1948 21.1665C18.1948 20.3306 18.8724 19.653 19.7083 19.653H23.2083C24.0442 19.653 24.7219 20.3306 24.7219 21.1665C24.7219 22.0024 24.0442 22.68 23.2083 22.68H19.7083C18.8724 22.68 18.1948 22.0024 18.1948 21.1665Z",
    fill: "url(#paint0_linear_1255_1116)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1255_1116",
    x1: 0.694824,
    y1: 12.921,
    x2: 25.8885,
    y2: 12.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3154C8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.ca630ada20e83483244ddc10adaf39ee.svg";
export { ForwardRef as ReactComponent };